
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Hero from "@/components/Hero";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

// Images
const heroImage = "/lovable-uploads/hero-flowerpot-view.jpeg";

const HeroSection = () => {
  return (
    <>
      {/* Hero Section */}
      <Hero 
        title="The Cottage" 
        titleSecondary="at Flowerpot"
        subtitle="A peaceful retreat in rural Tasmania for families, artists, writers and executives" 
        imageSrc={heroImage} 
        imageAlt="The Cottage at Flowerpot - 4 bedroom rural Tasmania accommodation for families and retreats"
        height="medium"
      >
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild className="bg-cottage-600 hover:bg-cottage-700 text-white font-medium px-6 py-6 drop-shadow-[0_2px_3px_rgba(0,0,0,0.5)]">
            <Link to="/contact">Contact</Link>
          </Button>
          <Button asChild className="bg-cottage-600 hover:bg-cottage-700 text-white font-medium px-6 py-6 drop-shadow-[0_2px_3px_rgba(0,0,0,0.5)]">
            <Link to="/book">Book</Link>
          </Button>
        </div>
      </Hero>

      {/* Location Badge */}
      <div className="flex justify-center -mt-8 relative z-10">
        <motion.div 
          className="flex items-center space-x-2 bg-white/80 backdrop-blur-sm rounded-full py-2 px-4 shadow-md" 
          initial={{ y: 20, opacity: 0 }} 
          animate={{ y: 0, opacity: 1 }} 
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <MapPin size={16} className="text-cottage-600" />
          <span className="text-cottage-800 font-medium text-sm">
            Flowerpot, Tasmania, Australia
          </span>
        </motion.div>
      </div>
    </>
  );
};

export default HeroSection;
